import "./styles/main.css";

const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const navbar = document.getElementById("navbar");
if (navbar) {
  const scrolledClasses = ["border-b", "border-[#E5E1D8]", "shadow-[0_1px_0_rgba(15,23,42,0.04)]"];
  const onScroll = (): void => {
    if (window.scrollY > 80) {
      navbar.classList.add(...scrolledClasses);
    } else {
      navbar.classList.remove(...scrolledClasses);
    }
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
}

const revealEls = document.querySelectorAll<HTMLElement>(".reveal-elem");
if (reduceMotion) {
  revealEls.forEach((el) => el.classList.add("is-visible"));
} else if ("IntersectionObserver" in window) {
  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          obs.unobserve(entry.target);
        }
      });
    },
    { root: null, rootMargin: "0px", threshold: 0.1 },
  );
  revealEls.forEach((el) => observer.observe(el));
} else {
  revealEls.forEach((el) => el.classList.add("is-visible"));
}

type PricingTab = "pass" | "spend" | "bundle";
const pricingTabs: PricingTab[] = ["pass", "spend", "bundle"];

function switchTab(tabId: PricingTab): void {
  pricingTabs.forEach((t) => {
    const panel = document.getElementById(`tab-${t}`);
    const btn = document.getElementById(`btn-tab-${t}`);
    if (panel) panel.classList.toggle("hidden", t !== tabId);
    if (!btn) return;
    if (t === tabId) {
      btn.classList.add("bg-[#FCFAF6]", "text-[#0F172A]", "shadow-sm", "border", "border-[#E5E1D8]");
      btn.classList.remove("text-[#475569]", "border-transparent");
      btn.setAttribute("aria-selected", "true");
    } else {
      btn.classList.remove("bg-[#FCFAF6]", "text-[#0F172A]", "shadow-sm", "border", "border-[#E5E1D8]");
      btn.classList.add("text-[#475569]", "border-transparent");
      btn.setAttribute("aria-selected", "false");
    }
  });
}

pricingTabs.forEach((t) => {
  const btn = document.getElementById(`btn-tab-${t}`);
  btn?.addEventListener("click", () => switchTab(t));
});
